import React from 'react';
import { SubTopicCard, SubTopicCardProps } from '@shapeable/ui';
import { withSubTopicAnchorPath } from '../../utils/sub-topic-anchor-path';

export const SubTopicAnchorCard: React.FC<SubTopicCardProps> = (props) => {
  const { entity, ...rest } = props;
  const anchorEntity = entity && withSubTopicAnchorPath(entity);

  return <SubTopicCard {...rest} entity={anchorEntity} />;
};
